import intlTelInput from 'intl-tel-input';
import 'inputmask/dist/jquery.inputmask.bundle';

function setInputMask ($element, mask = '99 999 9999') {
	$element.inputmask({
		mask: mask,
		clearMaskOnLostFocus: false,
		androidHack: window.Modernizr.android,
		disablePredictiveText: window.Modernizr.android,
		oncomplete () {
			$element.data('valid', true);
		},
		onincomplete () {
			$element.data('valid', false);
		}
	}).on('change.isComplete', () => {
		$element.data('valid', $element.inputmask('isComplete'));
	});
}

function phoneInput ($container = $('body')) {
	$container.find('.js-phone-input').each(function () {
		const $element = $(this);
		const iti = intlTelInput(this, {
			dropdownContainer: document.body,
			initialCountry: 'us',
			preferredCountries: ['us', 'ca', 'gb', 'de'],
			separateDialCode: true,
			autoPlaceholder: 'aggressive',
			utilsScript: '/Media/js/intl-tel-input-utils.js'
		});
		$element.on('countrychange', function() {
			const mask = $element.attr('placeholder');
			const countryData = iti.getSelectedCountryData();
			$element.val('');
			$element.data('code', countryData.dialCode);
			$element.attr('placeholder', mask.replace(/[0-9]/g, '_'));
			setInputMask($element, mask.replace(/[0-9]/g, 9));
		});
		$element.data('code', '1');
		$element.attr('placeholder', '___ ___ ____');
		setInputMask($element, '999-999-9999');
	});
}

export default phoneInput;



// WEBPACK FOOTER //
// ./src/js/_modules/phone-input.js